import React from "react";
import { Progress } from "../ui/progress";
import { Badge } from "../ui/badge";
import { useGamification } from "../../contexts/GamificationContext";

const XPBar = ({ showLabel = true, showLevel = true, size = "md", className = "" }) => {
  const { level, currentLevelXP, nextLevelXP, xpPercentage, levelColor, loading } = useGamification();

  if (loading) {
    return (
      <div className={`space-y-1 ${className}`}>
        <div className="h-4 bg-muted rounded animate-pulse"></div>
        <div className="h-2 bg-muted rounded animate-pulse w-3/4"></div>
      </div>
    );
  }

  const sizeClasses = {
    sm: "h-2",
    md: "h-3",
    lg: "h-4"
  };

  return (
    <div className={`space-y-1 ${className}`}>
      {showLevel && (
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <Badge
              variant="secondary"
              className="font-bold"
              style={{
                backgroundColor: levelColor,
                color: "white"
              }}
            >
              Level {level}
            </Badge>
            {showLabel && (
              <span className="text-sm text-muted-foreground">
                {currentLevelXP} / {nextLevelXP} XP
              </span>
            )}
          </div>
          <span className="text-sm font-semibold" style={{ color: levelColor }}>
            {xpPercentage}%
          </span>
        </div>
      )}
      <Progress
        value={xpPercentage}
        className={sizeClasses[size]}
        // Custom style for the progress bar fill
        style={{
          "--progress-background": levelColor
        }}
      />
    </div>
  );
};

export default XPBar;
